<template>
  <div>
    <div v-if="isLoadingOffers">
      <v-skeleton-loader v-for="i in 10" :key="i" type="list-item-avatar" />
    </div>
    <div v-else>
      <v-list-item
        v-for="offer in offers"
        :key="offer.id"
        @click="() => handleSelect(offer)"
      >
        <OfferListItem :offer="offer" />
      </v-list-item>
    </div>
  </div>
</template>

<script>
import OfferListItem from "@/views/offers/components/OfferListItem";

export default {
  name: "OfferList",
  components: { OfferListItem },
  props: {
    offers: Array,
    isLoadingOffers: Boolean
  },
  methods: {
    handleSelect(offer) {
      const id = offer.id;
      this.$router.push({
        name: "offerDetails",
        params: { id }
      });
    }
  }
};
</script>
